import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'mtg-spinner',
  templateUrl: './spinner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {
  @Input()
  progress: number;
  @HostBinding('class.spinner')
  defaultClass = true;

  constructor(
    private cdr: ChangeDetectorRef
  ) {
  }

  setProgress(progress: number): void {
    this.progress = progress;
    this.cdr.detectChanges();
  }
}
